"use client";

import React from "react";
import { v3 } from "@/lib/theme";
import { V3SectionHead } from "./V3SectionHead";
import { motion } from "framer-motion";

export function V3SectionTestimonials() {
  const items = [
    {
      initials: "MR",
      quote: "Ich habe jahrelang mit Excel hantiert und nie wirklich gewusst wie mein Portfolio steht. realpilot hat das in einer Stunde geändert.",
      name: "Michael R.",
      city: "Wien",
      count: 5,
    },
    {
      initials: "SK",
      quote: "Der Zinsalarm hat mich rechtzeitig an die Umschuldung erinnert. Die Verhandlung mit der Bank hat mir über € 6.000 gespart.",
      name: "Sandra K.",
      city: "Graz",
      count: 3,
    },
    {
      initials: "TW",
      quote: "Die Bankenpräsentation hat meinen Finanzierungsberater beeindruckt. So professionell hätte ich das nie selbst hinbekommen.",
      name: "Thomas W.",
      city: "Linz",
      count: 7,
    },
  ];

  return (
    <motion.section 
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{ padding: "120px 56px", background: v3.surf2, borderTop: `1px solid ${v3.line}`, borderBottom: `1px solid ${v3.line}` }} className="rp-section"
    >
      <V3SectionHead n={7} kicker="Was Eigentümer sagen"
        title="Drei Eigentümer."
        dimWord="Drei optimierte Portfolios." />

      <div className="rp-stack" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 20 }}>
        {items.map((it, i) => (
          <div key={i} style={{ background: v3.surf, border: `1px solid ${v3.line}`, borderRadius: 16, padding: 32, display: "flex", flexDirection: "column", gap: 20 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", gap: 3 }}>
                {[0,1,2,3,4].map((s) => (
                  <svg key={s} viewBox="0 0 16 16" width="14" height="14"><path d="M8 1 L10 6 L15 6 L11 9 L13 14 L8 11 L3 14 L5 9 L1 6 L6 6 Z" fill={v3.accent} /></svg>
                ))}
              </div>
              <div style={{ padding: "4px 10px", borderRadius: 999, border: `1px solid ${v3.line2}`, font: `11px ${v3.mono}`, color: v3.dim }}>
                {it.count} Objekte
              </div>
            </div>

            <p style={{ font: `17px/1.5 ${v3.sans}`, color: v3.fg, margin: 0, letterSpacing: "-0.01em", flex: 1 }}>
              „{it.quote}"
            </p>

            <div style={{ display: "flex", alignItems: "center", gap: 12, paddingTop: 16, borderTop: `1px solid ${v3.line}` }}>
              <div style={{ width: 40, height: 40, borderRadius: 99, background: v3.intense ? v3.accentBg : v3.surf2, border: `1px solid ${v3.intense ? v3.accentDim : v3.line2}`, color: v3.accent, display: "flex", alignItems: "center", justifyContent: "center", font: `500 13px ${v3.mono}` }}>
                {it.initials}
              </div>
              <div>
                <div style={{ font: `14px ${v3.sans}`, color: v3.fg, fontWeight: 500 }}>{it.name}</div>
                <div style={{ font: `12px ${v3.mono}`, color: v3.dim }}>{it.city} · {it.count} {it.count === 1 ? "Objekt" : "Objekte"}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.section>
  );
}
